import { customFetch } from "../helpers/customFetch";
import { URL, getConfig } from "../helpers/helpers";

export const employeeClassificationGet = async () => {
    try {
        const configs = getConfig('GET');
        const response = await customFetch(`${URL}employee_classifications/`, configs)
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        console.log(e);
    }
}

export const employeeClassificationGetByInduction = async (id) => {
    try {
        const configs = getConfig('GET');
        const response = await customFetch(`${URL}employee_classifications/induction/${id}`, configs)
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        console.log(e);
    }
}